module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/dbb64ea577f4998369992e3898775f85.png";